import React, {Component} from 'react';
import axios from 'axios';
import ModalComponent from  '../../../components/ModalComponent';
import { FaShoppingCart } from "react-icons/fa";
import { Card, CardBody, Table } from 'reactstrap';
import { connect } from 'react-redux';
import { Alert } from 'reactstrap';
import { Spinner } from 'react-bootstrap';
import PaginateComponent from "../../../components/PaginateComponent";
import ListOrderAllComponent from "../../../components/Customer/orders/ListOrderAllComponent";
import BreadcrumbCustomer from "../../../components/Layout/user/BreadcrumbCustomer";

class ListOrderUnpaidPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            loadPage: true,
            isLoading: true,
            listOrder: [],
            perPage: 0,
            totalPage: 0,
            currentPage: 0,
            error: false,
            messageError: '',
            isNotification: '',
            textNotification: '',
            isModal: false,
            titleModal: '',
            modalBody: '',
            action: '',
            isBtnConfirm: true,
            contentModal: '',
            btnConfirmDisabled: false,
            isSpinner: false,
            actionKey: 0,
            alert: {
                error: false,
                message: ''
            },
            typeOrder: ''
        }
    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.getListOrder();

        this.setState({
            isNotification: this.props.isNotification,
            textNotification: this.props.textNotification,
        })
        if ( this.props.isNotification ) {
            this.props.notification({
                isNotification: false,
                textNotification: ''
            });
        }
    }

    getListOrder = () => {
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let data = "?qtt=" + this.state.qtt + "&typeOrder=" + this.state.typeOrder;

        axios.get( process.env.REACT_APP_API_URL + '/api/order/getListOrderUnPaid' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                });
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listOrder: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    loadPage: false,
                    isLoading: false,
                    error: true,
                    messageError: 'Lấy dữ liệu đơn hàng thất bại',
                })
            })
    }

    changeQtt = (event) => {
        this.setState({
            qtt: event.target.value
        })
        this.getListOrder();
    }

    changeTypeOrder = (event) => {
        // console.log(event.target.value)
        this.search({
            typeOrder: event.target.value
        })
        this.getListOrder();
    }

    paginate = () => {
        if (this.state.totalPage > this.state.perPage) {
            return (
                <PaginateComponent
                    total={this.state.totalPage}
                    perPage={this.state.perPage}
                    currentPage={this.state.currentPage}
                    btnPaginate={ (page) => this.btnPaginate(page) }
                />
            );
        }
    }

    btnPaginate = (page) => {
        this.setState({
            isLoading: true
        });
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        // console.log(dataAuth);
        let data = "?qtt=" + this.state.qtt + "&typeOrder=" + this.state.typeOrder + "&page=" + page;
        axios.get( process.env.REACT_APP_API_URL + '/api/order/getListOrderUnPaid' + data,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                this.setState({
                    isLoading: false
                });
                if ( ref.data.error === 0 ) {
                    this.setState({
                        listOrder: ref.data.content.data,
                        perPage: ref.data.content.perPage,
                        totalPage: ref.data.content.total,
                        currentPage: ref.data.content.current_page,
                    })
                } else {
                    if ( ref.data.error === 9999 || ref.data.error === 9998 || ref.data.error === 9997 ) {
                        this.props.logOut();
                    } else {
                        this.setState({
                            error: true,
                            messageError: ref.data.message,
                        })
                    }
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isLoading: false
                });
                this.setState({
                    error: true,
                    messageError: 'Lấy dữ liệu đơn hàng thất bại',
                })
            })
    }

    screentListOrder = () => {
        if ( this.state.isLoading ) {
            return (
                <tr>
                    <td className="text-center" colSpan={12}>
                        <Spinner animation="grow" variant="primary" />
                        <Spinner animation="grow" variant="secondary" />
                        <Spinner animation="grow" variant="success" />
                        <Spinner animation="grow" variant="danger" />
                        <Spinner animation="grow" variant="warning" />
                        <Spinner animation="grow" variant="info" />
                    </td>
                </tr>
            );
        } else {
            if ( this.state.listOrder.length ) {
                return (
                    this.state.listOrder.map( (order, key) => {
                        return (
                            <ListOrderAllComponent
                                key={key}
                                order={order}
                                actionKey={key}
                                showModal = { (actionKey, action) => this.showModal(actionKey, action) }
                                loadInfo = { (actionKey) => this.loadInfo(actionKey) }
                            />
                        )
                    })
                )
            } else {
                return (
                    <tr>
                        <td className="text-center text-danger" colSpan="12">
                            Không có đơn hàng trong dữ liệu!
                        </td>
                    </tr>
                )
            }
        }
    }

    loadInfo = (actionKey) => {
        let listOrder = this.state.listOrder;
        if ( listOrder[actionKey].showInfo === 'show' ) {
            listOrder[actionKey].showInfo = '';
        } else {
            listOrder[actionKey].showInfo = 'show';
        }
        this.setState({
            listOrder: listOrder
        })
    }

    checkNotification = () => {
        if ( this.state.isNotification ) {
            return (
                <Alert color="success">
                    { this.state.textNotification }
                </Alert>
            );
        }
    }

    showModal = (actionKey, action) => {
        let titleModal;
        let modalBody;
        if ( action === 'infoOrder' ) {
            titleModal = 'Chi tiết đơn dặt hàng';
            modalBody = this.modalBody(actionKey, action);
        }
        else if ( action === 'deleteOrder' ) {
            titleModal = 'Xóa đơn dặt hàng';
            modalBody = this.modalBody(actionKey, action);
        }
        this.setState({
            action: action,
            isModal: true,
            btnConfirmDisabled: false,
            contentModal: {
                modalBody: modalBody,
                title: titleModal
            },
            isBtnConfirm: true,
            isSpinner: false,
            actionKey: actionKey
        })
    }

    hiddenModal = () => {
        this.setState({
            actionKey: 0,
            action: '',
            isModal: false,
        })
    }

    modalBody = (actionKey, action) => {
        if ( action === 'deleteOrder' ) {
            return (
                <div className="text-center">
                    Bạn có muốn hủy đơn đặt hàng này không? <br />
                </div>
            )
        }
    }

    confirmModal = () => {
        this.setState({
            btnConfirmDisabled: true,
            isSpinner: true,
            isBtnConfirm: false,
            alert: {
                error: false,
                message: ''
            }
        })
        let dataAuth = {
            username: process.env.REACT_APP_CLIENT_ID,
            password: process.env.REACT_APP_CLIENT_PASSWD,
            token: process.env.REACT_APP_KEY,
        };
        let form = {
            orderId: this.state.listOrder[ this.state.actionKey ].id,
            action: this.state.action
        };

        axios.put( process.env.REACT_APP_API_URL + '/api/order/action', form,
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization' : this.props.token,
                    'dataAgency' : JSON.stringify(dataAuth)
                }
            }
        )
            .then( (ref) => {
                // console.log(ref.data);
                this.setState({
                    isSpinner: false,
                });
                if ( ref.data.error > 9000 ) {
                    this.props.logOut();
                } else {
                    if ( !ref.data.error ) {
                        window.scrollTo(0, 0);
                        this.getListOrder();
                    }
                    this.setState({
                        contentModal: {
                            modalBody: this.modalBodyConfirm(ref.data.error,ref.data.message),
                            title: this.state.contentModal.title
                        },
                    })
                }
                // console.log(this.state.perPage);
            })
            .catch( (error) => {
                console.log(error);
                this.setState({
                    isSpinner: false,
                    contentModal: {
                        title: this.state.contentModal.title,
                        modalBody: this.modalBodyConfirm(1, 'Thực hiện hành động không thành công')
                    },
                })
            })
    }

    modalBodyConfirm = (error, message) => {
        if ( error ) {
            return (
                <div className="text-center text-danger">
                    { message }
                </div>
            )
        } else {
            return (
                <div className="text-center text-success">
                    { message }
                </div>
            )
        }
    }

    render() {
        return (
            <>
                {
                    this.state.loadPage ? (
                        <div className="cr-page-spinner load-page">
                            <Spinner animation="border" variant="primary" />
                        </div>
                    ) : (
                        <>
                            <BreadcrumbCustomer title={"Quản lý tất cả đơn hàng"} page={"Đơn hàng"} icon={<FaShoppingCart className="breadcrumb-icon"/>} />
                            <Card>
                                <CardBody>
                                    <div className="col-12">
                                    </div>
                                    <div className="row">
                                        <div className="col-md-12">
                                            {
                                                this.checkNotification()
                                            }
                                        </div>
                                        <div className="col col-md-12 table-responsive">
                                            <Table className="table table-sm table-bordered table-hover rounded text-center">
                                                <thead>
                                                    <tr>
                                                        <th>Mã đơn hàng</th>
                                                        <th>Loại</th>
                                                        <th>Ngày đặt hàng</th>
                                                        <th>Tổng tiền</th>
                                                        <th>Trạng thái</th>
                                                        <th>Hành động</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    { this.screentListOrder() }
                                                </tbody>
                                            </Table>
                                            { this.paginate() }
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                            <ModalComponent
                                isModal={ this.state.isModal }
                                content={this.state.contentModal}
                                isBtnConfirm={ this.state.isBtnConfirm }
                                isSpinner={ this.state.isSpinner }
                                btnConfirmDisabled={ this.state.btnConfirmDisabled }
                                hiddenModal={ () => this.hiddenModal() }
                                confirmModal={ () => this.confirmModal() }
                                alert={ this.state.alert }
                            />
                        </>
                    )
                }
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        token: state.login.token,
        isNotification: state.adminMain.isNotification,
        textNotification: state.adminMain.textNotification,
    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        logOut: () => {
            dispatch(({ type : 'logOut', page: 'CustomerOrderUnpaid' }))
        },
        notification: (item) => {
            dispatch(({ type : 'notification', item }))
        },
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(ListOrderUnpaidPage);